<template>
  <div class="course-detail-page">
    <!-- 视频播放区（顶部 + 固定16:9比例） -->
    <div class="play-container" v-if="currentVideo.video_cos_url">
      <div class="video-wrapper">
        <video
          :src="currentVideo.video_cos_url"
          controls
          class="video-player"
          @ended="playNextVideo"
        >
          您的浏览器不支持视频播放
        </video>
      </div>
    </div>

    <!-- 课程标题 -->
    <div class="cover-area">
      <h2 class="course-title">{{ courseInfo.title }}</h2>
    </div>

    <!-- 标签栏 -->
    <div class="tab-bar">
      <div class="tab-item" :class="{ active: activeTab === 'catalog' }" @click="activeTab = 'catalog'">目录</div>
      <div class="tab-item" :class="{ active: activeTab === 'details' }" @click="activeTab = 'details'">详情</div>
    </div>

    <!-- 内容区域 -->
    <div class="content-area">
      <!-- 目录 -->
      <div v-if="activeTab === 'catalog'">
        <div class="video-list">
          <div
            v-for="(video, index) in courseInfo.videos"
            :key="index"
            class="video-item"
            :class="{ active: currentVideoIndex === index }"
            @click="playVideo(index)"
          >
            <span class="video-name">{{ video.video.name }}</span>
          </div>
          <div class="empty-tip" v-if="courseInfo.videos.length === 0">暂无匹配的章节</div>
        </div>
      </div>

      <!-- 详情 -->
      <div v-else-if="activeTab === 'details'">
        <p class="details-desc">{{ courseInfo.description || '暂无课程详情' }}</p>
      </div>

      <!-- 评论（示例，若不需要可直接删除该分支） -->
      <div v-else>
        <p>评论区待完善</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { ElMessage } from 'element-plus';
import http from '@/util/request';

// 状态
const route = useRoute();
const courseInfo = ref({ title: '', cover_url: '', description: '', videos: [] });
const currentVideoIndex = ref(0);
const currentVideo = ref({ video_cos_url: '', name: '' });
const activeTab = ref('catalog');

// 获取课程详情
const fetchCourseDetail = () => {
  const courseId = route.query.courseId;
  if (!courseId) {
    ElMessage.error('课程 ID 不存在');
    return;
  }
  http.get(`/api/ok/courses/${courseId}/`)
    .then(res => {
      courseInfo.value = res.data;
      if (courseInfo.value.videos.length) {
        playVideo(0);
      }
    })
    .catch(err => {
      ElMessage.error('获取课程详情失败');
      console.error(err);
    });
};

// 播放指定视频
const playVideo = (index) => {
  if (index < 0 || index >= courseInfo.value.videos.length) return;
  currentVideoIndex.value = index;
  currentVideo.value = {
    video_cos_url: courseInfo.value.videos[index].video.video_cos_url,
    name: courseInfo.value.videos[index].video.name
  };
};

// 播放下一个视频
const playNextVideo = () => {
  if (currentVideoIndex.value < courseInfo.value.videos.length - 1) {
    playVideo(currentVideoIndex.value + 1);
  } else {
    ElMessage.info('已播放完所有视频');
  }
};

// 页面加载时获取详情
onMounted(() => {
  fetchCourseDetail();
});
</script>

<style scoped>
.course-detail-page {
  background-color: #fff;
  min-height: 100vh;
  padding-bottom: 10px;
}

.play-container {
  width: 100%;
  background-color: #000;
  padding: 0 10px;
  box-sizing: border-box;
}

.video-wrapper {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  overflow: hidden;
}

.video-player {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.cover-area {
  padding: 10px;
}

.course-title {
  font-size: 25px;
  font-weight: bold;
  color: #333;
  margin: 0;
}

.tab-bar {
  display: flex;
  border-bottom: 1px solid #eee;
  margin: 0 10px;
}

.tab-item {
  flex: 1;
  text-align: center;
  padding: 12px 0;
  font-size: 20px;
  cursor: pointer;
  color: #666;
}

.tab-item.active {
  color: #ff7f24;
  border-bottom: 2px solid #ff7f24;
  font-weight: 500;
}

.content-area {
  padding: 10px;
}

.video-list {
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 5px 0;
}

.video-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 10px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  font-size: 20px;
}

.video-item:last-child {
  border-bottom: none;
}

.video-item.active {
  background-color: #ffebe0;
  color: #ff7f24;
}

.video-name {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 10px;
}

.details-desc {
  line-height: 1.6;
  color: #333;
  font-size: 14px;
  padding: 0 5px;
}

.empty-tip {
  text-align: center;
  padding: 30px 0;
  color: #999;
  font-size: 14px;
}
</style>